var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrow2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 32,
    viewBox: "0 0 8 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.41603 0.72265C2.26285 0.492886 1.95241 0.430799 1.72265 0.583975C1.49289 0.737151 1.4308 1.04759 1.58397 1.27735L2.41603 0.72265ZM1.50971 31.0981C1.56387 31.3688 1.82728 31.5444 2.09806 31.4903L6.51067 30.6078C6.78145 30.5536 6.95706 30.2902 6.9029 30.0194C6.84875 29.7486 6.58534 29.573 6.31456 29.6272L2.39223 30.4117L1.60777 26.4893C1.55361 26.2185 1.2902 26.0429 1.01942 26.0971C0.748639 26.1513 0.573032 26.4147 0.627187 26.6854L1.50971 31.0981ZM1.58397 1.27735L2.70878 2.96455L3.54083 2.40985L2.41603 0.72265L1.58397 1.27735ZM2.70878 29.0355L1.58398 30.7227L2.41603 31.2773L3.54083 29.5901L2.70878 29.0355ZM2.70878 2.96455C7.9712 10.8582 7.9712 21.1418 2.70878 29.0355L3.54083 29.5901C9.02718 21.3606 9.02718 10.6394 3.54083 2.40985L2.70878 2.96455Z",
    fill: "#8B997F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow2);
export default __webpack_public_path__ + "static/media/arrow-2.2b86ab3d901cd4f17f245bf591f827d7.svg";
export { ForwardRef as ReactComponent };